import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { EventModel } from 'src_common/common/websocket2/models/EventModel';
import { MatchLead } from 'src/domains/sportsbook/webview/components/matchLead/MatchLead';
import { MatchLeadNBA } from 'src/domains/sportsbook/webview/components/matchLead/matchLeadNBA/MatchLeadNBA';
import { MatchLeadMLB } from 'src/domains/sportsbook/webview/components/matchLead/matchLeadMLB/MatchLeadMLB';
import { LiveTracker } from 'src/domains/sportsbook/webview/components/scoreboards/liveTracker/LiveTracker';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';

interface PropsType {
    event: EventModel | null;
}

export const MatchLeadWrapper = observer<PropsType>('MatchLeadWrapper', ({ event }) => {
    const common = useCommon();
    const configComponents = ConfigComponents.get(common);
    const { scoreboard, liveTrackerForFootballOutrights } = configComponents.config;

    if (event === null) {
        return null;
    }

    const competitionData = event.competition2.getModel()?.getData();

    if (competitionData === undefined) {
        return null;
    }

    /**
     * Hide standard scoreboard for StarSport
     * @description
     * Sport: cricket;
     * competition: 'England County Championship Division One'
     * competition: England County Championship Division Two
     */
    if (
        competitionData.sport === 'cricket' &&
        (competitionData.name === 'England County Championship Division One' ||
            competitionData.name === 'England County Championship Division Two')
    ) {
        return null;
    }

    if (
        liveTrackerForFootballOutrights === false &&
        event.template === 'outrights' &&
        competitionData.sport === 'football'
    ) {
        return null;
    }

    if (event.template.startsWith('two-participant')) {
        if (competitionData.name.includes('Major League Baseball') === true) {
            return (
                <>
                    <MatchLeadMLB
                        key={event.id}
                        event={event}
                    />
                    {scoreboard.liveTracker?.includes('baseball') === true && (
                        <LiveTracker
                            sport={event.sport}
                            eventId={event.id2.toOldId()}
                            isOpen={event.timeMatchInPlay}
                        />
                    )}
                </>
            );
        }

        if (competitionData.name.split(' ').includes('NBA') === true) {
            if (scoreboard.liveTracker === null) {
                return (
                    <MatchLeadNBA
                        key={event.id}
                        event={event}
                    />
                );
            }

            for (const item of scoreboard.liveTracker) {
                if (item === 'basketball') {
                    return <MatchLead event={event} />;
                }
            }

            return (
                <MatchLeadNBA
                    key={event.id}
                    event={event}
                />
            );
        }
    }

    return <MatchLead event={event} />;
});
